import React, { useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Snowfall from "react-snowfall";
import "./App.css";
import Lottie from "lottie-react";
import GreetingCard from "./GreetingCard";
import santa from "./lotties/santa.json";
import reindeer from "./lotties/reindeer-gifts.json";
import star from "./lotties/shooting-star.json";
import fallback from "./default.jpg";
import AdminPanel from "./AdminPanel";
import { fetchMessageById, fetchSettings } from "./api";

function App() {
  const isAdminView = window.location.pathname.startsWith("/admin");
  const dialogRef = useRef(null);
  const [showGreetingCard, setShowGreetingCard] = useState(false);
  const [cardContent, setCardContent] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState("");
  const [defaultImagePath, setDefaultImagePath] = useState("");

  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = isAdminView ? "auto" : "hidden";
    return () => {
      document.body.style.overflow = previous || "auto";
    };
  }, [isAdminView]);

  const openDialog = () => {
    setShowGreetingCard(true);
    dialogRef.current.showModal();
  };

  const closeDialog = () => {
    setShowGreetingCard(false);
    dialogRef.current.close();
    if (document.activeElement !== document.body) document.activeElement.blur();
  };

  const resolveHeaderImage = (content) => {
    if (!content) return fallback;
    if (content.imagePath) return content.imagePath;
    if (defaultImagePath) return defaultImagePath;
    return fallback;
  };

  useEffect(() => {
    fetchSettings()
      .then((data) => {
        setDefaultImagePath(data.defaultImagePath || "");
      })
      .catch(() => {
        setDefaultImagePath("");
      });

    const params = new URLSearchParams(window.location.search);
    const messageId = params.get("id");
    if (!messageId) {
      setCardContent(null);
      setIsButtonDisabled(true);
      return;
    }

    setIsLoading(true);
    setLoadError("");
    fetchMessageById(messageId)
      .then((data) => {
        setCardContent(data);
        setIsButtonDisabled(false);
      })
      .catch(() => {
        setCardContent(null);
        setIsButtonDisabled(true);
        setLoadError("Greeting nicht gefunden.");
      })
      .finally(() => setIsLoading(false));
  }, []);

  if (isAdminView) {
    return <AdminPanel />;
  }

  return (
    <div className="App">
      <Snowfall
        snowflakeCount={80}
        wind={[-0.25, 0.1]}
        speed={[-0.5, 0.5]}
        radius={[1, 5.0]}
      />
      <div className="moon"> </div>
      <div className="player"></div>
      <button
        className="cta"
        onClick={() => {
          openDialog();
        }}
        disabled={isButtonDisabled}
      >
        <div className="gift"></div>
      </button>
      {isLoading && <div className="cta-hint">Lade Gruß...</div>}
      {loadError && <div className="cta-hint error">{loadError}</div>}

      <Lottie className="santa" animationData={santa} loop={true} />
      <Lottie className="reindeer" animationData={reindeer} loop={true} />
      <Lottie className="star" animationData={star} loop={false} />
      <div className="trees"> </div>
      <div className="landscape"></div>

      <dialog ref={dialogRef} className="greeting-dialog">
        {showGreetingCard &&
          ReactDOM.createPortal(
            <GreetingCard
              headerImage={resolveHeaderImage(cardContent)}
              altText={cardContent?.salutation || "Greeting header"}
              salutation={cardContent?.salutation}
              message={cardContent?.message}
              greeting={cardContent?.greeting}
              onClose={closeDialog}
            />,
            dialogRef.current
          )}
      </dialog>
    </div>
  );
}

export default App;
